import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableOfContents = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.33337 3C4.05723 3 3.83337 3.22386 3.83337 3.5C3.83337 3.77614 4.05723 4 4.33337 4H11.6667C11.9429 4 12.1667 3.77614 12.1667 3.5C12.1667 3.22386 11.9429 3 11.6667 3H4.33337ZM4.33337 5C4.05723 5 3.83337 5.22386 3.83337 5.5C3.83337 5.77614 4.05723 6 4.33337 6H8.33337C8.60952 6 8.83337 5.77614 8.83337 5.5C8.83337 5.22386 8.60952 5 8.33337 5H4.33337ZM4.33337 7C4.05723 7 3.83337 7.22386 3.83337 7.5C3.83337 7.77614 4.05723 8 4.33337 8H11.6667C11.9429 8 12.1667 7.77614 12.1667 7.5C12.1667 7.22386 11.9429 7 11.6667 7H4.33337ZM3.83337 13.5C3.83337 13.2239 4.05723 13 4.33337 13H11.6667C11.9429 13 12.1667 13.2239 12.1667 13.5C12.1667 13.7761 11.9429 14 11.6667 14H4.33337C4.05723 14 3.83337 13.7761 3.83337 13.5ZM4.33337 9C4.05723 9 3.83337 9.22386 3.83337 9.5C3.83337 9.77614 4.05723 10 4.33337 10H8.33337C8.60952 10 8.83337 9.77614 8.83337 9.5C8.83337 9.22386 8.60952 9 8.33337 9H4.33337ZM3.83337 11.5C3.83337 11.2239 4.05723 11 4.33337 11H8.33337C8.60952 11 8.83337 11.2239 8.83337 11.5C8.83337 11.7761 8.60952 12 8.33337 12H4.33337C4.05723 12 3.83337 11.7761 3.83337 11.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default TableOfContents
